import React, { useState, useMemo } from 'react';
import {
    Body,
    ModalContent,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
    ModalTitle,
} from '@/styles/blocks';
import { Grid, MenuItem, TextField } from '@material-ui/core';
import { Body2 } from '../blocks';
import { css } from '@emotion/react';
import { colors } from '@/styles';

const DiagnosticModal = ({ order, callbacks }) => {
    const [selected, setSelected] = useState(null);

    const cancel = () => {
        setSelected(null);
        callbacks.setDiagnostic({});
    };

    const error = useMemo(() => {
        if (!selected) {
            return null;
        }

        const split = selected.split(':');
        const final = split[0];
        const middle = split[1] || null;

        return order?.last_pricing_run?.instances?.find((instance) => {
            return (
                instance?.final_mile?.override?.assign?.client_id === final &&
                (middle ? instance?.middle_mile?.override?.assign?.client_id === middle : true)
            );
        })?.final_mile?.error;
    }, [order, selected]);

    return (
        <ResponsiveSidebarDialog maxWidth="lg" open={!!order}>
            <ModalTitle border title={order ? `${order?.order_number} - Diagnostics` : ''} onClose={cancel} />
            <ModalContent
                css={css`
                    min-width: 700px;
                `}
            >
                <Grid direction="column" container>
                    <Grid
                        itemdirection="row"
                        container
                        css={css`
                            margin-bottom: 16px;
                        `}
                    >
                        <TextField
                            label="Carriers"
                            fullWidth
                            select
                            variant="outlined"
                            size="small"
                            value={selected}
                            onChange={(e) => setSelected(e.target.value)}
                        >
                            {(order?.last_pricing_run?.instances || []).map((instance) => {
                                let label = 'Marketplace';
                                let key = 'marketplace';
                                if (instance?.final_mile?.override?.assign) {
                                    label = instance?.final_mile?.override?.assign?.business_name;
                                    key = instance?.final_mile?.override?.assign?.client_id;
                                }
                                if (instance?.middle_mile) {
                                    label = `${instance?.middle_mile?.override?.assign?.business_name} > ${instance?.final_mile?.override?.assign?.business_name}`;
                                    key = `${instance?.final_mile?.override?.assign?.client_id}:${instance?.middle_mile?.override?.assign?.client_id}`;
                                }

                                return (
                                    <MenuItem key={key} value={key}>
                                        <Body2>{label}</Body2>
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                    {selected ? (
                        <Grid itemdirection="row" container>
                            <Grid
                                direction="column"
                                container
                                css={css`
                                    border: 1px solid #c0c0c0;
                                    background-color: ${colors.greys[4]};
                                    border-radius: 4px;
                                    padding: 12px;
                                `}
                            >
                                <Body2
                                    css={css`
                                        color: #d23e3e;
                                    `}
                                >
                                    {error}
                                </Body2>
                            </Grid>
                        </Grid>
                    ) : null}
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <SecondaryButton onClick={cancel}>Close</SecondaryButton>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default DiagnosticModal;
